module.exports = "0x59DEb352f5259ED290318cb5C1364CB5e0f91399"


// WEBPACK FOOTER //
// ./src/contracts/Artists.1.address.js